import http from "../http-common";

class UserDataService {

    checkStatus(){
        return fetch(`${process.env.REACT_APP_AUTH_URL}/api/auth/session`, {
            credentials: 'include'
        }).then(res => res.json());
    }
    
    getUserInfo(email){
        return http.get(`/users/getUserByEmail?email=${email}`, {
            withCredentials: true
        });
    }

    registerNewUser(data) {
        return http.post("/users", data, {
            withCredentials: true
        });
    }

    // Returns a combination of both hardware and software tickets of specified user
    getAllMyTickets(id) {
        return http.get(`/users/${id}/tickets`, {
            withCredentials: true 
        });
    }

    // Returns a combination of both hardware and software open tickets of specified user
    getMyOpenTickets(id) {
        return http.get(`/users/${id}/openTickets`, {
            withCredentials: true
        });
    }

    getMyOpenHardwareTickets(id) {
        return http.get(`/users/${id}/openHardwareTickets`, {
            withCredentials: true
        });
    }

    getMyOpenSoftwareTickets(id) {
        return http.get(`/users/${id}/openSoftwareTickets`, {
            withCredentials: true
        });
    }

    getAllMyHardwareTickets(id) {
        return http.get(`/users/${id}/hardwareTickets`, {
            withCredentials: true
        });
    }

    getAllMySoftwareTickets(id) {
        return http.get(`/users/${id}/softwareTickets`, {
            withCredentials: true
        });
    }

    getPermissions(id) {
        return http.get(`/users/${id}/permissions`, {
            withCredentials: true
        });
    }

    getRequesterList(tenant_id, user_id) {
        return http.get(`/users/requesterList?tenantId=${tenant_id}&userId=${user_id}`, {
            withCredentials: true
        });
    }

    getUserList(tenantId, userIdAsking, roleId, offset, searchText, sortBy, sortOrder) {
        return http.get(`/users/userList?tenantId=${tenantId}&userIdAsking=${userIdAsking}&roleId=${roleId}&offset=${offset}&searchText=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}`, {
            withCredentials: true
        });
    }

    // get the list of possible roles for display in the user list filter drop down
    getRoleList() {
        return http.get(`/users/roleList`, {
            withCredentials: true
        });
    }

    getUserProfileData(user_id, userIdAsking) {
        return http.get(`/users/${user_id}/userProfileData?userIdAsking=${userIdAsking}`, {
            withCredentials: true
        });
    }

    // get info on the ticket submitter for display in the information modal
    getTicketSubmitterDetails(submitter_id) {
        return http.get(`/users/ticketSubmitterDetails?submitterId=${submitter_id}`, {
            withCredentials: true
        });
    }

    // edit a user record
    editUser(user_id, data) {
        return http.put(`/users/${user_id}/editUser`, data, {
            withCredentials: true
        });
    }

    getTenantName(tenant_id) {
        return http.get(`/users/getTenantName?tenantId=${tenant_id}`, {
            withCredentials: true
        });
    }

    // getAll() {
    //     return http.get("/accounts", {headers: {Authorization: 'Bearer ' + token}});
    // }

    // create(data) {
    //     return http.post("/accounts", data, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // get(id) {
    //     return http.get(`/accounts/${id}`, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // update(id, data) {
    //     return http.put(`/accounts/${id}`, data, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // delete(id) {
    //     return http.delete(`/accounts/${id}`, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // findByName(name) {
    //     return http.get(`/accounts?name=${name}`);
    // }
}

export default new UserDataService();